import { useRef, useState } from "react";
import { EmptyProcess, IProcess, Table } from "./Table";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";

export interface IModal {
    singleData: IProcess,
    open: boolean
}

export const Process = (permissions: IPermissionProps) => {
    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyProcess, open: false });
    };
    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload}></Table>
            <Toast ref={toast} />
        </>
    );
}